import { blockConfig } from '../config';
import { viewIds } from '../config/view';

// eslint-disable-next-line
const calculateItemBlockDimensions = (
  startMoment,
  endMoment,
  dayStartHour,
  dayEndHour,
  dayStartEndHour,
  dateRef,
  dayDiffMinutes,
  durationInMinutes,
  durationTravelToInMinutes,
  durationTravelFromInMinutes,
  durationLabourInMinutes,
  durationDiffItemBlock,
  durationFullItemBlock = 0,
  fullDay,
) => {
  if (
    ((startMoment.isAfter(dayStartHour) || startMoment.isSame(dayStartHour)) &&
      startMoment.isBefore(dayEndHour) &&
      (endMoment.isBefore(dayEndHour) || endMoment.isSame(dayEndHour))) ||
    fullDay
  ) {
    // 1 - if block starts after the starting hour of the day and ends before the end hour
    return {
      left: startMoment.diff(dateRef, 'minutes') - (dayDiffMinutes - durationDiffItemBlock),
      duration: durationInMinutes,
      travelToDuration: durationTravelToInMinutes,
      travelFromDuration: durationTravelFromInMinutes,
      labourDuration: durationLabourInMinutes,
    };
  } else if (startMoment.isBefore(dayStartHour) && endMoment.isAfter(dayEndHour)) {
    // 2 - if block starts before the starting hour of the day and ends after the end hour
    const durationTravelToBlock =
      durationTravelToInMinutes - dayStartHour.diff(startMoment, 'minutes');
    const durationTravelFromBlock =
      durationTravelFromInMinutes - endMoment.diff(dayEndHour, 'minutes');

    return {
      left: dayStartHour.diff(dateRef, 'minutes') - (dayDiffMinutes - durationDiffItemBlock),
      duration: durationFullItemBlock || dayEndHour.diff(dayStartHour, 'minutes'),
      travelToDuration: durationTravelToBlock > 0 ? durationTravelToBlock : 0,
      travelFromDuration: durationTravelFromBlock > 0 ? durationTravelFromBlock : 0,
      labourDuration: durationLabourInMinutes,
      arrows: blockConfig.arrows.both,
    };
  } else if (
    startMoment.isBefore(dayStartHour) &&
    (endMoment.isBefore(dayEndHour) || endMoment.isSame(dayEndHour))
  ) {
    // 3 - if block starts before the starting hour of the day and ends before the end hour
    const durationTravelToBlock =
      durationTravelToInMinutes - dayStartHour.diff(startMoment, 'minutes');
    const durationTravelFromBlock =
      durationTravelFromInMinutes < endMoment.diff(dayStartHour, 'minutes') ?
        durationTravelFromInMinutes : endMoment.diff(dayStartHour, 'minutes');
    return {
      left: dayStartHour.diff(dateRef, 'minutes') - (dayDiffMinutes - durationDiffItemBlock),
      duration: endMoment.diff(dayStartHour, 'minutes'),
      travelToDuration: durationTravelToBlock > 0 ? durationTravelToBlock : 0,
      travelFromDuration: durationTravelFromBlock,
      labourDuration: durationLabourInMinutes,
      arrows: blockConfig.arrows.left,
    };
  } else if (
    (startMoment.isAfter(dayStartHour) || startMoment.isSame(dayStartHour)) &&
    startMoment.isBefore(dayEndHour) &&
    endMoment.isAfter(dayEndHour)
  ) {
    // 4 - if block starts after the starting hour of the day and ends after the end hour
    const durationTravelToBlock =
      durationTravelToInMinutes < dayEndHour.diff(startMoment, 'minutes') ?
        durationTravelToInMinutes : dayEndHour.diff(startMoment, 'minutes');
    const durationTravelFromBlock =
      durationTravelFromInMinutes - endMoment.diff(dayEndHour, 'minutes');

    return {
      left: startMoment.diff(dateRef, 'minutes') - (dayDiffMinutes - durationDiffItemBlock),
      duration: dayStartEndHour.diff(startMoment, 'minutes'),
      travelToDuration: durationTravelToBlock,
      travelFromDuration: durationTravelFromBlock > 0 ? durationTravelFromBlock : 0,
      labourDuration: durationLabourInMinutes,
      arrows: blockConfig.arrows.right,
    };
  }

  return false;
};

export const isAfterHours = (block, ganttDimensions, viewDimensions) => {
  const { widthDay } = ganttDimensions;
  const { endHour, workingDays, startHour } = viewDimensions;

  const dayStartHour = block.startMoment?.clone().set({ hour: startHour, minute: 0, second: 0 });
  const dayEndHour = block.startMoment?.clone().set({ hour: endHour, minute: 0, second: 0 });
  const nextDayStartHour = dayStartHour.clone().add(1, 'days');
  if (
    (block.startMoment.isAfter(dayEndHour) || block.startMoment.isSame(dayEndHour)) &&
    (block.endMoment.isBefore(nextDayStartHour) ||
      block.endMoment.isSame(nextDayStartHour))
  ) {
    let amountDay = 1;
    // get daynumber of week
    const day = block.startMoment.day();
    // get index of workingDays
    const index = workingDays?.indexOf(day);
    if (index) {
      amountDay += index;
    }

    return {
      ...block,
      left: amountDay * widthDay,
      amountDay,
    };
  } else if (
    block.startMoment.isBefore(dayStartHour) &&
    (block.endMoment.isBefore(dayStartHour) || block.endMoment.isSame(dayStartHour))
  ) {
    let amountDay = 0;
    // get daynumber of week
    const day = block.startMoment.day();
    // get index of workingDays
    const index = workingDays?.indexOf(day);
    if (index) {
      amountDay += index;
    }

    return {
      ...block,
      left: amountDay * widthDay,
      amountDay,
    };
  }

  return false;
};

export const getTopDimension = (block) => {
  const line = block.line - 1;
  // This code can be used for calculations/improvements later
  // if (block.type !== blockConfig.types.fieldService) {
  //   return line * blockConfig.smallHeight;
  // }
  return (line * blockConfig.height) + ((line + 1) * 3);
};

export const getTotalLines = blocks =>
  // eslint-disable-next-line
  Math.max.apply(
    Math,
    blocks?.map(block => block.line),
  );

// If there are no daybreakers, show 1 block instead of splitted blocks
const calculateFullDayBlocks = (itemBlockDimension, widthDimension) => {
  const dimensionLeft = itemBlockDimension.left * widthDimension;
  const dimensionRight = dimensionLeft + (itemBlockDimension.duration * widthDimension);
  // The block starts before the start of the view and ends before the end of the view
  if (dimensionLeft < 0 && dimensionRight < 99.9) {
    const fullDayTravelTo = itemBlockDimension.travelToDuration - (itemBlockDimension.left * -1);
    const durationLeft = (itemBlockDimension.left * -1) - itemBlockDimension.travelToDuration;
    return {
      ...itemBlockDimension,
      left: 0,
      duration: itemBlockDimension.duration - (itemBlockDimension.left * -1),
      travelToDuration: fullDayTravelTo < 0 ? 0 : fullDayTravelTo,
      labourDuration: itemBlockDimension.labourDuration - durationLeft < 0 ?
        0 :
        itemBlockDimension.labourDuration - durationLeft,
      // eslint-disable-next-line
      travelFromDuration: itemBlockDimension.travelFromDuration < itemBlockDimension.duration - (itemBlockDimension.left * -1) ?
        itemBlockDimension.travelFromDuration :
        itemBlockDimension.duration - (itemBlockDimension.left * -1),
      arrows: blockConfig.arrows.left,
    };
    // The block starts after the start of the view and ends after the end of the view
  } else if (dimensionRight > 99.9 && dimensionLeft > 0) {
    const durationRight = (dimensionRight - 100) / widthDimension;
    const durationLeft = (100 / widthDimension) - itemBlockDimension.left;
    return {
      ...itemBlockDimension,
      duration: itemBlockDimension.duration - durationRight,
      // eslint-disable-next-line
      travelFromDuration: durationLeft - itemBlockDimension.travelToDuration - itemBlockDimension.labourDuration < 0 ?
        0 :
        durationLeft - itemBlockDimension.travelToDuration - itemBlockDimension.labourDuration,
      labourDuration: durationLeft - itemBlockDimension.travelToDuration < 0 ?
        0 :
        durationLeft - itemBlockDimension.travelToDuration,
      travelToDuration: itemBlockDimension.travelToDuration > durationLeft ?
        durationLeft :
        itemBlockDimension.travelToDuration,
      arrows: blockConfig.arrows.right,
    };
    // The block starts before the start of the view and ends after the end of the view
  } else if (dimensionRight > 99.9 && dimensionLeft < 0) {
    const fullDayTravelTo = itemBlockDimension.travelToDuration - (itemBlockDimension.left * -1);
    const travelToDuration = fullDayTravelTo < 0 ? 0 : fullDayTravelTo;
    const labourDuration = (100 / widthDimension) - travelToDuration < 0 ?
      0 :
      (100 / widthDimension) - travelToDuration;
    const travelFromDuration = (100 / widthDimension) - travelToDuration - labourDuration;
    return {
      ...itemBlockDimension,
      left: 0,
      // eslint-disable-next-line
      duration: itemBlockDimension.duration - (itemBlockDimension.left * -1) - ((dimensionRight - 100) / widthDimension),
      travelFromDuration: travelFromDuration < 0 ? 0 : travelFromDuration,
      travelToDuration,
      labourDuration,
      arrows: blockConfig.arrows.both,
    };
  }
  // The block starts after the start of the view and ends before the end of the view
  return itemBlockDimension;
};

const isHiddenDay = (view, day) => {
  if (view?.id === viewIds.twoWorkWeeks || view?.id === viewIds.oneWorkWeek) {
    if (view?.parameters?.workingDays?.includes(day)) {
      return false;
    }
    return true;
  }
  return false;
};
// eslint-disable-next-line complexity
const getItemBlockDimensions = (
  {
    startMoment,
    endMoment,
    durationInMinutes,
    durationTravelToInMinutes,
    durationTravelFromInMinutes,
    durationLabourInMinutes,
  },
  startHour,
  endHour,
  dateRef,
  endDateRef,
  hasDayBreakers,
  widthDimension,
  view,
) => {
  const dayStartEndHour = startMoment?.clone().set({ hour: endHour, minute: 0, second: 0 });

  const blockStartDate = startMoment?.clone().startOf('day');
  const blockEndDate = endMoment?.clone().startOf('day');

  const fullDay = () => {
    if (!hasDayBreakers) {
      return true;
    }
    return false;
  };

  let amountDaysCoveredAbsolute = 1;
  if (!fullDay()) {
    amountDaysCoveredAbsolute = Math.abs(blockStartDate.diff(blockEndDate, 'days')) + 1;
  }

  const amountHours = endHour - startHour;
  const itemBlockDimensions = [];

  for (let d = 0; d < amountDaysCoveredAbsolute; d += 1) {
    const day = startMoment?.add(d, 'day');
    const dayNumber = day.day();

    const viewStart = dateRef?.clone().set({ hour: 0, minute: 0 });
    const viewEnd = endDateRef?.clone().subtract(1, 'day')
      .set('hour', 23)
      .set('minute', 59)
      .set('second', 59);

    const dayOffset = view?.parameters?.startOfWeek;

    // dont do this for days that are not in the view
    if (!isHiddenDay(view, dayNumber) && (
      fullDay() ||
      (day.isSameOrAfter(viewStart) && day.isSameOrBefore(viewEnd))
    )) {
      const dayStartHour = day.clone().set({ hour: startHour, minute: 0, second: 0 });
      const dayEndHour = day.clone().set({ hour: endHour, minute: 0, second: 0 });
      const dayCount = dayNumber - dayOffset;

      const dayDiffMinutes = dayCount * 24 * 60;
      const durationFullItemBlock = amountHours * 60;
      const durationDiffItemBlock = dayCount * durationFullItemBlock;
      let itemBlockDimension = null;
      let fullItemBlock = false;
      let dateRefBase = dateRef;
      let isNextWeek = false;
      let nextWeekOffset = 0;
      if (view.id === viewIds.twoWorkWeeks && day.isSameOrAfter(viewStart.add(7, 'day'))) {
        nextWeekOffset = 5 * durationFullItemBlock;
        isNextWeek = true;
        dateRefBase = viewStart.add(7, 'day').set({ hour: startHour, minute: 0, second: 0 });
      }

      // full days between itemBlocks
      if (
        amountDaysCoveredAbsolute > 1 &&
        d !== 0 &&
        d !== amountDaysCoveredAbsolute - 1
      ) {
        fullItemBlock = true;
      }

      // item block Dimension left and duration
      itemBlockDimension = calculateItemBlockDimensions(
        startMoment,
        endMoment,
        dayStartHour,
        dayEndHour,
        dayStartEndHour,
        dateRefBase,
        dayDiffMinutes,
        durationInMinutes,
        durationTravelToInMinutes,
        durationTravelFromInMinutes,
        durationLabourInMinutes,
        durationDiffItemBlock,
        fullItemBlock ? durationFullItemBlock : 0,
        fullDay(),
      );

      if (itemBlockDimension) {
        if (fullDay()) {
          // Don't send dayNumber if fullDay because it will always be set to the startDay
          // and the block is not splitted over multiple days
          const itemBlock = calculateFullDayBlocks(itemBlockDimension, widthDimension);
          itemBlockDimensions.push({
            day: dayCount,
            ...itemBlock,
            isLast: itemBlock.arrows !== 'both' && itemBlock.arrows !== 'right',
          });
        } else {
          itemBlockDimensions.push({
            day: dayCount,
            ...itemBlockDimension,
            left: itemBlockDimension.left,
            isNextWeek,
            nextWeekOffset,
            isLast: d === amountDaysCoveredAbsolute - 1,
          });
        }
      }
    }
  }

  // make sure blocks with a negative duration are not shown
  return itemBlockDimensions?.filter(itemBlocks => itemBlocks.duration > 0);
};

export default getItemBlockDimensions;
